import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Lightspeed from './views/Lightspeed.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        meta: {
            title: `${process.env.VUE_APP_TITLE}`,
        },
        component: Home,
    }, {
        path: '/lightspeed/configure',
        name: 'lightspeed',
        meta: {
            title: `${process.env.VUE_APP_TITLE} - Lightspeed Configurator`,
        },
        component: Lightspeed,
    }],
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
});

export default router;
